import { z } from "zod/mini";

import {
  DeployEnvironmentSchema,
  envRequire,
  Nullable,
  PostHogSchema,
  SentrySchema,
} from "@animus/utils/environment";

const BaseEnvironmentSchema = z.object({
  DEPLOY_ENVIRONMENT: DeployEnvironmentSchema,
  GIT_SHA: Nullable(z.string()),
  APP_VERSION: Nullable(z.string()),
  API_BASE_URL: z.string().check(z.url()),
  ZERO_CACHE_URL: z.string().check(z.url()),
  SENTRY: Nullable(SentrySchema),
  POSTHOG: Nullable(PostHogSchema),
});

type BaseEnvironment = z.infer<typeof BaseEnvironmentSchema>;

export const EnvironmentSchema = BaseEnvironmentSchema.check(
  envRequire<BaseEnvironment>(
    ["production", "pr-preview"],
    ["GIT_SHA", "APP_VERSION", "SENTRY", "POSTHOG"]
  )
);

type ParsedEnvironment = z.infer<typeof EnvironmentSchema>;

/** Derived values computed from validated environment */
export interface DerivedEnvironment {
  /** Whether Sentry error tracking is configured */
  SENTRY_ENABLED: boolean;
  /** Whether PostHog analytics is configured */
  POSTHOG_ENABLED: boolean;
  /** Sentry release identifier (APP_VERSION) */
  SENTRY_RELEASE: string | null;
}

export type Environment = ParsedEnvironment & DerivedEnvironment;
